const getDefaultState = () => {
  return {
    necJwt: '',
    nbAlert: 0,
    messages: [],
  };
};

const state = getDefaultState();

const actions = {
  reset({ commit }) {
    commit('RESET');
  },
};

const mutations = {
  RESET(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },
  RESET_NEC_JWT(state) {
    state.necJwt = '';
  },
  RESET_NB_ALERT(state) {
    state.nbAlert = 0;
  },
  RESET_MESSAGES(state) {
    state.messages = [];
  },
  // Mettre à jour une seule préférence
  SET_NEC_JWT(state, valeur) {
    state.necJwt = valeur;
  },
  SET_NB_ALERT(state, valeur) {
    state.nbAlert = valeur;
  },
  SET_MESSAGES(state, valeur) {
    state.messages = Array.isArray(valeur) ? [...valeur] : [];
  },
  APPEND_MESSAGES(state, valeur) {
    if (!Array.isArray(valeur)) {
      return;
    }

    const existingMessageIds = new Set(state.messages.map((message) => message.id));
    const newMessages = valeur.filter((message) => {
      if (existingMessageIds.has(message.id)) {
        return false;
      }

      existingMessageIds.add(message.id);
      return true;
    });

    state.messages = [...state.messages, ...newMessages];
  },
  SET_MESSAGE_AS_READ(state, { messageId, readDate }) {
    const messageIndex = state.messages.findIndex((message) => message.id === messageId);

    if (messageIndex === -1) {
      return;
    }

    state.messages.splice(messageIndex, 1, {
      ...state.messages[messageIndex],
      readState: true,
      readDate,
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
